<template>
  <home-section
    :title="section.title"
    :subtitle="section.subtitle"
    :loading="loading"
    :error="error"
    :is-empty="!items.length"
    :variant="section.type"
    :skeleton-variant="railVariant"
    :skeleton-count="5"
    @retry="$emit('retry', section)"
  >
    <home-project-rail
      :items="items"
      :label="section.title"
      :variant="railVariant"
      :card="cardType"
      :card-label="cardLabel"
      @favorite-changed="$emit('favorite-changed', $event)"
    />
  </home-section>
</template>

<script>
import HomeSection from "./HomeSection.vue";
import HomeProjectRail from "@/components/home/rails/HomeProjectRail.vue";

export default {
  name: "HomeProjectSection",
  components: { HomeSection, HomeProjectRail },
  props: {
    section: { type: Object, required: true },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
  computed: {
    cardType() {
      if (this.section.type === "editorial") return "editorial";
      return "project";
    },
    railVariant() {
      if (["originals", "exclusives"].includes(this.section.id)) return "editorial-originals";
      if (["project", "completed"].includes(this.section.type)) return "projects-large";
      return this.section.type === "editorial" ? "editorial" : "projects";
    },
    cardLabel() {
      if (this.section.id === "originals") return "Original";
      if (this.section.id === "exclusives") return "Exclusivo";
      return "";
    },
  },
};
</script>
